export const ROUTERS_PATH = {
    LOGIN: "/login",
    PLAYGROUND: "/playground",
    DISPLAY_BOOK: "/display-book/:bookId"
}